import PropTypes from 'prop-types';
import {
	Card,
	CardContent,
	Typography,
	// Button,
	Box,
	CardActions,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { format } from 'date-fns';

const ActiveProductCard = ({ product, handleOpenDrawer }) => {
	const theme = useTheme();

	return (
		<Card
			sx={{
				height: '100%',
				cursor: 'pointer',
				backgroundColor: theme.palette.background.paper,
				border: `1px solid ${theme.palette.divider}`,
				'&:hover': { backgroundColor: theme.palette.action.hover },
			}}
			onClick={() => handleOpenDrawer(product)}
		>
			<CardContent>
				<Box
					sx={{
						display: 'flex',
						justifyContent: 'space-between',
						alignItems: 'center',
					}}
				>
					<Typography variant='h5' color={theme.palette.text.primary}>
						{product.name}
					</Typography>
					{product.logo && (
						<img
							src={product.logo}
							alt={`${product.name} logo`}
							style={{ width: '40px', height: '40px' }}
						/>
					)}
				</Box>
				<Typography variant='body2' color={theme.palette.text.secondary}>
					Since:{' '}
					{format(new Date(product.subscription_details.since), 'MM-dd-yyyy')}
				</Typography>
				<Typography variant='body2' color={theme.palette.text.secondary}>
					Licenses: {product.subscription_details.num_licenses}
				</Typography>
			</CardContent>
			<CardActions>
				{/* <Button size='small' color='primary'>
          Manage Subscription
        </Button> */}
			</CardActions>
		</Card>
	);
};

ActiveProductCard.propTypes = {
	product: PropTypes.object.isRequired,
	handleOpenDrawer: PropTypes.func.isRequired,
};

export default ActiveProductCard;
